<template lang="pug">
  y-dialog(fill-height fluid v-model="showModal" scrollable transition="fade-transition" persistent max-width="600px")
    v-card(flat)
      v-card-title.px-5.basic200.pb-0
        v-row(no-gutters)
          v-col
            h6.basic800--text {{ $t('update_billplz') }}
          v-col.shrink
            v-btn.mr-n2(text icon @click="showModal = !showModal" height)
              v-icon(color="primary" :size="24") mdi-close

      v-card-text.pa-0(flat)
        v-form(ref="form")
          v-layout.my-6(v-if="isFetching")
            v-row.fill-height.ma-0(align='center' justify='center')
              v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
          v-card.pa-4(v-else-if="!isFetching")
            .api-key
              p.mb-3.label.basic600--text.text-uppercase.mt-2 {{ $t('api_key.label') }}
              v-text-field.p1(solo flat background-color="basic200"    height="40" v-model='apiKey' :label="$t('api_key.label')" :placeholder="$t('api_key.placeholder')" outlined dense persistent-hint :rules="rules.not_empty")

            .signature-key
              p.mb-3.label.basic600--text.text-uppercase.mt-2 {{ $t('signature_key.label') }}
              v-text-field.p1(solo flat background-color="basic200"    height="40" v-model='signatureKey' :label="$t('signature_key.label')" :placeholder="$t('signature_key.placeholder')" outlined dense persistent-hint :rules="rules.valid_key")

            .collection-id
              p.mb-3.label.basic600--text.text-uppercase.mt-2 {{ $t('collection_id.label') }}
              v-text-field.p1(solo flat background-color="basic200"    height="40" v-model='collectionId' :label="$t('collection_id.label')" :placeholder="$t('collection_id.placeholder')" outlined dense persistent-hint :rules="rules.not_empty")

            .payment-channel
              v-layout.mt-0
                div.s1.basic1000--text {{ $t('payment_channel') }}
              y-checkbox.mt-1(v-model="channel" hide-details dense value="fpx")
                template(v-slot:label) 
                  div.p1.default--text FPX
              y-checkbox.mt-1(v-model="channel" hide-details dense value="senangpay")
                template(v-slot:label) 
                  div.p1.default--text {{ $t('credit_debit_card') }} (Senangpay)

            //- v-col.mt-4.pa-0.background-inventory(cols="12")
            //-   v-card-actions.pa-0
            //-     v-row(dense)
            //-       v-col.py-0.pr-0
            //-         v-layout
            //-           v-btn.mx-auto(color='primary' text block height="32" small :style="{ 'background-color': (accountEnabled == true)? '#D9EAFE' : '', 'border-radius' : 0 }" @click="accountEnabled = true")
            //-             | {{ $t('enabled') }}
            //-       v-divider.grey(vertical)
            //-       v-col.py-0.pl-0
            //-         v-btn(color='primary', text block height="32" small :style="{ 'background-color': accountEnabled == false? '#D9EAFE' : '', 'border-radius' : 0 }" @click="accountEnabled = false")
            //-           | {{ $t('disabled') }}

    
      v-card-actions(flat)
        v-spacer
        v-btn.button-Aa-small(color='primary400', text @click='showModal = false')
          | {{ $t('Cancel') }}
        v-btn.button-AA-medium.mr-2.white--text(color='info500' depressed height=32 :loading="isLoading" @click='clickSave')
          | {{ $t('update') }}

</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'UpdateBillPlz',
  props: ['open', 'company'],
  data: () => ({
    fullscreen: true,
    isFetching: true,
    apiKey: null,
    signatureKey: null,
    channel: ['fpx'],
    collectionId: null,
    accountEnabled: true,
    gatewayId: null,
    isLoading: false,
    rules: {
      not_empty: [val => (val || '').length > 0 || 'This field is required'],
      valid_key: [
        val => (val || '').length > 0 || 'This field is required',
        val => val.length > 20 || 'Invalid format. Example: S-a*_4p**Bal***1E5a***98',
      ]
    }
  }),
  computed: {
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  mounted () {
    this.fullscreen = window.innerWidth < 600
  },
  created () {
    this.fetchSettings()
  },
  methods: {
     ...mapActions([
      'showMessage'
    ]),
    fetchSettings () {
      this.$axios.get(`/billplz_creds/?company=${this.company.id}`).then((response) => {
        if (response.data.results.length != 0) {
          const gateway = response.data.results[0]
          this.gatewayId = gateway.id
          this.apiKey = gateway.api_key
          this.signatureKey = gateway.signature_key
          this.accountEnabled = gateway.enabled
          this.collectionId = gateway.collection_id
          this.channel = gateway.channel
        }
        this.isFetching = false
      })
      .catch(() => {})
    },
    clickSave() {
      if (!this.$refs.form.validate()) {
        return
      }
      this.isLoading = true
      var params = new FormData();
      params.set('company', this.company.id)
      params.set('api_key', this.apiKey)
      params.set('signature_key', this.signatureKey)
      params.set('collection_id', this.collectionId)
      params.set('enabled', this.accountEnabled)
      params.set('channel', JSON.stringify(this.channel))
      if (this.gatewayId) {
        this.axios.put(`/billplz_creds/${this.gatewayId}/`, params)
        .then(resp => {
          console.log(resp)
          this.showModal = false
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
        return
      }
      this.axios.post(`/billplz_creds/`, params)
        .then(resp => {
          this.$emit('activated', resp.data)
          this.showModal = false
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  }
}
</script>

<style scoped>
.background-inventory {
  border-style: solid;
  border-width: 1px;
  border-color: grey;
  border-radius: 2px;
}
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}

.v-card--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
</style>

<i18n>
{
  "en": {
    "update_billplz": "Update Billplz",
    "api_key": {
      "label": "API key",
      "placeholder": "Write your Billplz secret key here"
    },
    "signature_key": {
      "label": "XSignature Key",
      "placeholder": "Write your XSignature payment key here"
    },
    "collection_id": {
      "label": "Collection id",
      "placeholder": "Write your collection id here"
    },
    "payment_channel": "Payment channel",
    "credit_debit_card": "Credit / Debit Card"
  }
}
</i18n>
